import api from "@/services/api";

export default {
  fetchMessages(payload) {
    return api.post(`messages/get_conversation_messages/`, payload);
  },
  postMessage(payload) {
    return api.post(`messages/`, payload);
  },
  getContentType(model) {
    return api.get(`content_type/`, model).then(response => response.data);
  }
};
